(() => {
  class LazerCartUpsells extends HTMLElement {
    connectedCallback() {
      this.onClick = this.onClick.bind(this);
      this.addEventListener('click', this.onClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }

    async onClick(event) {
      const button = event.target.closest('[data-lz-add-variant]');
      if (!button || button.getAttribute('aria-busy') === 'true') return;

      const variantId = Number.parseInt(button.dataset.lzAddVariant, 10);
      if (!Number.isFinite(variantId)) return;

      event.preventDefault();
      button.setAttribute('aria-busy', 'true');
      const originalLabel = button.textContent;
      button.textContent = button.dataset.loadingText || 'Ekleniyor…';
      const status = button.closest('[data-lz-upsell-item]')?.querySelector('[data-lz-status]');

      try {
        const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        const formData = new FormData();
        formData.append('id', String(variantId));
        formData.append('quantity', '1');

        if (cart?.getSectionsToRender) {
          formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
          cart.setActiveElement?.(button);
        }

        // `Accept: application/javascript` ŞART. `window.routes.cart_add_url`
        // `/cart/add.js` değil `/cart/add`; Accept başlığı olmadan Shopify bunu
        // normal form gönderimi sayıp /cart'a YÖNLENDİRİYOR ve HTML döndürüyor.
        // O hâlde ürün sepete ekleniyor ama `response.json()` patlıyor: sepet
        // güncellenmiyor, çekmece açılmıyor, müşteri hiçbir şey olmadı sanıyor.
        // Dawn kendi isteklerinde bunu `fetchConfig('javascript')` ile yapıyor.
        const response = await fetch(window.routes.cart_add_url, {
          method: 'POST',
          headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: formData,
        });

        let data;
        try {
          data = await response.json();
        } catch {
          throw new Error('Ürün sepete eklenemedi.');
        }

        if (!response.ok || data.status) {
          throw new Error(data.description || data.message || 'Ürün sepete eklenemedi.');
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'lazer-upsell',
            productVariantId: variantId,
            cartData: data,
          });
        }

        if (document.querySelector('#MainContent')?.dataset.template === 'cart') {
          window.location.reload();
          return;
        }

        if (cart?.renderContents) {
          cart.renderContents(data);
        } else {
          window.location.assign(window.routes.cart_url);
        }
      } catch (error) {
        if (status) status.textContent = error.message || 'Bir hata oluştu.';
        button.textContent = originalLabel;
        button.removeAttribute('aria-busy');
      }
    }
  }

  if (!customElements.get('lazer-cart-upsells')) {
    customElements.define('lazer-cart-upsells', LazerCartUpsells);
  }
})();

/* ── Sepete ekleme popup'ı ──────────────────────────────────────────
 *
 * Ürün sayfasından sepete ekleyince Dawn `cart-drawer`ı açıyor. Biz o
 * seferlik açılışı bastırıp kendi teklif penceremizi gösteriyoruz.
 *
 * Neden `open()` yamalanıyor da sonradan `close()` çağrılmıyor:
 * `renderContents` çekmeceyi setTimeout içinde açıyor ve açılış bir CSS
 * geçişi. Sonradan kapatmak gözle görülür bir "açıldı-kapandı" titremesi
 * bırakıyordu. Açılışı hiç başlatmamak temiz.
 *
 * `renderContents` yine çalışır — sepet içeriği ve ikon sayacı güncellenir,
 * yalnızca panel görünmez. Müşteri teklifi geçerse "Sepete Git" onu açar.
 *
 * ⚠ YÜKLEME SIRASI. Bu dosya `layout/theme.liquid`de 320. satırda,
 * `cart-drawer.js` ise 445. satırda yükleniyor — ikisi de `defer`. Yani biz
 * çalışırken <cart-drawer> henüz UPGRADE EDİLMEMİŞ oluyor: `drawer.open`
 * undefined. İlk sürümde `drawer.open.bind(...)` orada patlıyor ve altındaki
 * `subscribe` kaydı hiç kurulmuyordu; popup sessizce hiç açılmadı, çekmece
 * normal açıldı. Bu yüzden:
 *   1) kurulum DOMContentLoaded'a bırakıldı (tüm defer betiklerinden sonra),
 *   2) yama `customElements.whenDefined` ile bekletiliyor,
 *   3) abonelik yamadan ÖNCE kuruluyor — yama patlasa bile popup çalışsın.
 */
(() => {
  const secim = (s, k = document) => k.querySelector(s);

  let modal = null;
  let sonOdak = null;
  let bastir = false;

  /** Teklif kartı yoksa popup hiç açılmaz — çekmece normal davranışına döner. */
  const teklifVar = () => !!(modal && modal.querySelector('.lz-upsell-card'));

  function ac() {
    if (!teklifVar()) return false;
    sonOdak = document.activeElement;

    // Giriş animasyonu YALNIZCA sekme görünürken. Arka plandaki sekmede
    // tarayıcı animasyon/geçiş zaman çizelgesini donduruyor: panel geçişin
    // BAŞLANGIÇ değerinde (ekranın altında) takılı kalıyor ve müşteri geri
    // döndüğünde yalnızca karartıyı görüyor. Animasyonu atlamak, bozuk
    // görünmekten iyidir — panel doğrudan yerinde belirir.
    const animasyonlu =
      !document.hidden && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (animasyonlu) modal.classList.add('lz-giris');
    modal.hidden = false;
    document.body.classList.add('overflow-hidden', 'lz-modal-acik');

    if (animasyonlu) {
      // Bir kare sonra kaldır → CSS geçişi oradan doğar.
      requestAnimationFrame(() => modal.classList.remove('lz-giris'));
      // Güvence: rAF hiç çalışmazsa panel giriş konumunda kalmasın.
      setTimeout(() => modal.classList.remove('lz-giris'), 400);
    }

    (modal.querySelector('.lz-upsell-modal__close') || modal).focus({ preventScroll: true });
    return true;
  }

  function kapat() {
    if (!modal || modal.hidden) return;
    modal.classList.remove('lz-giris');
    modal.hidden = true;
    document.body.classList.remove('lz-modal-acik');

    // Çekmece açıksa sayfa kilidini BIRAKMA — o da aynı sınıfı kullanıyor.
    // Teklif kabul edildiğinde ikisi kısa süre üst üste biniyor; koşulsuz
    // kaldırmak arkadaki sayfayı çekmece açıkken kaydırılabilir yapıyordu.
    const drawer = secim('cart-drawer');
    if (!drawer || !drawer.classList.contains('active')) {
      document.body.classList.remove('overflow-hidden');
    }
    sonOdak?.focus?.({ preventScroll: true });
  }

  function cekmeceyiAc() {
    kapat();
    const drawer = secim('cart-drawer');
    if (drawer && typeof drawer.open === 'function') drawer.open();
    else window.location.assign(window.routes.cart_url);
  }

  function kur() {
    modal = secim('[data-lz-upsell-modal]');
    if (!modal) return;

    modal.addEventListener('click', (e) => {
      // Panelin dışına, yani karartıya tıklandı.
      if (e.target === modal) return kapat();
      if (e.target.closest('[data-lz-modal-kapat]')) return kapat();
      if (e.target.closest('[data-lz-modal-sepet]')) return cekmeceyiAc();
      // Teklif kabul edildi: ürün eklendi, artık sepeti göstermek doğru olan.
      // `lazer-cart-upsells` kendi eklemesini yapıp çekmeceyi açıyor; biz
      // yalnızca pencereyi çekiliyoruz ki arkada asılı kalmasın.
      if (e.target.closest('[data-lz-add-variant]')) setTimeout(kapat, 700);
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal && !modal.hidden) kapat();
    });

    // Abonelik ÖNCE: yama başarısız olsa bile popup açılsın.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        // Yalnızca ürün sayfasındaki asıl "Sepete Ekle" butonu. Popup'ın kendi
        // içinden yapılan eklemeler ('lazer-upsell') çekmeceyi açmaya devam etsin.
        if (event?.source !== 'product-form') return;
        if (!teklifVar()) return;
        bastir = true;
        // renderContents açılışı setTimeout(0)'a alıyor; bir tik sonra
        // gösteriyoruz ki bastırma önce tüketilsin.
        setTimeout(() => {
          if (!ac()) bastir = false;
        }, 60);
      });
    }

    customElements.whenDefined('cart-drawer').then(() => {
      const drawer = secim('cart-drawer');
      if (!drawer || drawer.__lzYamali || typeof drawer.open !== 'function') return;
      const asilOpen = drawer.open.bind(drawer);
      drawer.open = function (tetikleyen) {
        if (bastir) {
          bastir = false;
          return;
        }
        return asilOpen(tetikleyen);
      };
      drawer.__lzYamali = true;
    });
  }

  // 'interactive' hâli defer betikleri çalışırken de geçerli; o an cart-drawer
  // henüz tanımlı değil. DOMContentLoaded tüm defer betiklerinden SONRA gelir.
  if (document.readyState === 'complete') kur();
  else window.addEventListener('DOMContentLoaded', kur, { once: true });
})();
